export { default } from './tabs';
